import { render, staticRenderFns } from "./Cmoneda.vue?vue&type=template&id=6a48b132&"
import script from "./Cmoneda.vue?vue&type=script&lang=js&"
export * from "./Cmoneda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports